const model = {
  id: null,
  name: null,
  ids: {},
  children: []
};
const editor = {};

const state = {
  view: "model-list",
  mode: null,
  activeCard: false,
  activeCardId: null,
  activeRoute: {
    reverse: false,
    reverseRouteId: null
  },
  overlay: false,
  selectedRoute: null,
  flyToRoute: null,
  transportSystems: null,
  loadingLayers: [],
  saved: false,
  model,
  editor
};

const mutations = {
  SET_PT_MODEL(state, { id, name, ids, children }) {
    state.model.id = id;
    state.model.name = name;
    state.model.ids = ids;
    state.model.children = children;
  },
  SET_SELECTED_ROUTE(state, selected) {
    state.selectedRoute = selected;
  },
  FLY_TO_ROUTE(state, route) {
    state.flyToRoute = route;
  },
  CLEAR_PT_MODEL(state) {
    state.model = {
      ...model
    };
  },
  SET_PT_STATE_PROP(state, { name, value }) {
    state[name] = value;
  },
  ADD_PT_LOADING_LAYER(state, id) {
    if (state.loadingLayers.indexOf(id) === -1) state.loadingLayers.push(id);
  },
  REMOVE_PT_LOADING_LAYER(state, id) {
    state.loadingLayers.splice(state.loadingLayers.indexOf(id), 1);
  },
  SET_ACTIVE_ROUTE_PROPS(state, { reverse, reverseRouteId }) {
    state.activeRoute.reverse = reverse;
    state.activeRoute.reverseRouteId = reverseRouteId;
  },
  SET_PT_UPDATED(state, value) {
    state.saved = value;
  }
};

export default {
  state,
  mutations
};
